import React, { useState } from "react";
import { LanguageSwitcher } from "sunday-component";
import { IMenuHeaderProps, Language } from "../IHeader";
import SundayLogo from "../SundayLogo/SundayLogo";
import MainMenu from "../MainMenu/MainMenu";
import MobileMainMenu from "../MainMenu/MobileMainMenu";
import {
  Content,
  HeaderContainer,
  Left,
  Right,
  Header,
  LogoContainer,
} from "./MenuHeader.style";

const MenuHeader = ({
  onChangeLanguage,
  language,
  showSwitchLanguage,
  menus,
  content,
}: IMenuHeaderProps): JSX.Element => {
  const [subMenuVisible, setSubMenuVisible] = useState(false);
  const availableLanguage: Language[] = content?.supportedLangs.map((lang) => {
    return lang.code as Language;
  });

  return (
    <Header style={{ width: subMenuVisible ? "100vw" : "100%" }}>
      <HeaderContainer>
        <Content>
          <Left>
            <LogoContainer>
              <SundayLogo
                content={{
                  headerLogoLink: content?.headerLogoLink,
                  headerLogoImageUrl:
                    "https://static.easysunday.com/retail/artifacts/sunday-logo.svg",
                }}
              />
            </LogoContainer>
            <MainMenu
              subMenuVisible={subMenuVisible}
              setSubMenuVisible={setSubMenuVisible}
              menus={menus}
            />
          </Left>
          <Right>
            <LanguageSwitcher
              availableLanguages={availableLanguage}
              showSwitch={showSwitchLanguage}
              onChangeLanguage={onChangeLanguage}
              language={language}
            />
            <MobileMainMenu
              availableLanguage={availableLanguage}
              showSwitch={showSwitchLanguage}
              onChangeLanguage={onChangeLanguage}
              language={language}
              menus={menus}
            />
          </Right>
        </Content>
      </HeaderContainer>
    </Header>
  );
};

export default MenuHeader;
